import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Confirm } from "../../components/confirm";
import { deletePerson } from "../../services/person";
import { useLocale } from "../../stores/locale";
import { navigateBack } from "../../utils/navigate-back";

export function PersonDelete() {
  const navigate = useNavigate();
  const locale = useLocale((state) => state);
  const queryClient = useQueryClient();
  const { id } = useParams();

  if (!id) {
    throw new Error("Person ID is required");
  }

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    navigateBack(navigate, "/admin/register/person");
  };

  return (
    <>
      <Confirm
        header={locale.get("person.confirmDelete")}
        loading={loading}
        onClose={closeModal}
        onConfirm={() => {
          (async () => {
            setLoading(true);
            try {
              await deletePerson(id);
              await queryClient.invalidateQueries({
                queryKey: ["persons"],
              });
            } finally {
              setLoading(false);
              closeModal();
            }
          })();
        }}
      />
    </>
  );
}
